import { get, post } from '@api/request';

export async function fetchNewYearLayerRuns(
  { appraisalService },
  authenticationToken,
  { page = 1, pageSize = 200 },
) {
  const url = `${appraisalService}/certification/nyl/runs?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export const createNewYearLayer = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/certification/nyl/runs`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const undoNewYearLayer = async (
  { appraisalService },
  authenticationToken,
  { runID },
) => {
  const url = `${appraisalService}/certification/nyl/run/${runID}/undo`;
  const { body } = await post(authenticationToken, url);
  return body;
};
